<template>
  <div class="text-input_question">
    <Formfield :required="required" :helpText="helpText" :label="label">
      <TextInput
        class="text-input_question__radio-list"
        v-model="inputValue"
        v-bind="inputProps"
      />
    </Formfield>
  </div>
</template>

<script>
import BaseComponent from "../BaseComponent";
import Formfield from "./Formfield.vue";
import TextInput from "../atoms/Inputs/TextInput.vue";
import InputBase from "../atoms/Inputs/mixins/InputBase";
import FormMixin from "../mixins/FormMixin";

/**
 * @group Questions
 * TextInput with a Formfield wrapped around it.
 * See TextInput and Formfield documentation for clearer explanation of the props.
 * This component just passes its props on.
 *
 * This component passes all it's props to it's child component which is a TextInput
 */
export default {
  name: "TextInputQuestion",
  mixins: [BaseComponent, InputBase, FormMixin],
  components: {
    TextInput,
    Formfield,
  },
  props: {
    // The Question
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    // The Hint
    helpText: {
      type: String,
    },
    // The placeholder of the Text Input Field nested inside
    placeholder: {
      type: String,
    },
  },
  computed: {
    inputProps() {
      return {
        ...this.$props,
        ...this.$attrs,
        label: this.$props.placeholder,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style_variables/style_variables.scss";

.text-input_question {
  width: 100%;
  max-width: 576px;
}
</style>
